import { BadClientPageModule } from './pages/contract/bad-client/bad-client.module';
/* eslint-disable @typescript-eslint/promise-function-async */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';
import { PageGuard } from '@guards/page.guard';
import { NewQuotation } from './pages/flow-routes/new-quotation/new-quotation.routing';

const routes: Routes = [
  {
    path: RoutePaths.EMPTY.route,
    redirectTo: RoutePaths.GENERIC_ERROR.route,
    pathMatch: 'full',
  },
  {
    path: RoutePaths.COMPONENTS_PREVIEW.route,
    loadChildren: () =>
      import('@pages/components-preview/components-preview.module').then(m => m.ComponentsPreviewPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.MAINTENANCE_PAGE.route,
    loadChildren: () => import('@pages/maintenance/maintenance.module').then(m => m.MaintenancePageModule),
    canActivate: [PageGuard],
  },
  {
    path: RoutePaths.GENERIC_ERROR.route,
    loadChildren: () => import('@pages/generic-error/generic-error.module').then(m => m.GenericErrorPageModule),
    canActivate: [PageGuard],
  },
  ...NewQuotation,
  {
    path: RoutePaths.WILDCARD.route,
    redirectTo: RoutePaths.GENERIC_ERROR.route,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
